/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_RequiredInputs */

const cs_auth_totp_required = /** @type {(inputs: Auth_Totp_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je vyžadováno dvoufázové ověření.`)
};

const en_auth_totp_required = /** @type {(inputs: Auth_Totp_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-factor authentication is required.`)
};

/**
* | output |
* | --- |
* | "Two-factor authentication is required." |
*
* @param {Auth_Totp_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_totp_required = /** @type {((inputs?: Auth_Totp_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_totp_required(inputs)
	return cs_auth_totp_required(inputs)
});